/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client"; // only for production mode in the React v18
// import ReactDOM from "react-dom"; // - only for old React-version
// eslint-disable-next-line import/named
import { Provider } from "react-redux";
import * as serviceWorker from "./libs/serviceWorker";
import store from "./libs/store.ts";
import RzApp from "./app.tsx";
// import fnc from "./libs/fnc.ts";
// ======================================
const { $ } = window;
/* eslint-enabled @typescript-eslint/no-unused-vars */

// After load page
$(document).ready(() => {
  // Load fast user settings
  const cnt = $("#pagecontainer");
  if (cnt[0]) {
    console.log("=============== Starting React App! ===============");
    // Start React-app
    const root = createRoot(cnt[0]);
    // New React version:
    root.render(<StrictMode><Provider store={store}><RzApp /></Provider></StrictMode>);
    // Old React versions supported this method:
    // ReactDOM.render((<StrictMode><Provider store={store}><RzApp /></Provider></StrictMode>), cnt[0]);
  }
});
// ======================================

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
